import { createSelector } from 'reselect';
import { contains } from 'underscore';
import { RequestStatus } from 'smart-content-core/constants';
export const getAdAccounts = state => state.adSources.byAccountId;
export const getAdSourceListStatus = state => {
  return state.adSources.fetchStatusById;
};
export const getAdSourceListStatusById = (state, props) => {
  return state.adSources.fetchStatusById[props.criterionId] || RequestStatus.UNINITIALIZED;
};
export const getAdAcount = (state, props) => state.adSources.byAccountId[props.accountId];
const getAdCampaigns = createSelector([getAdAccounts], byAccountId => {
  return Object.values(byAccountId).reduce((acc, adAccountId) => {
    const {
      adCampaigns = {}
    } = adAccountId;
    return /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */(
      acc.concat(Object.values(adCampaigns))
    );
  }, []);
});
export const getAdCampaignOptions = createSelector([getAdCampaigns], adCampaigns => {
  if (!adCampaigns.length) return [];
  return adCampaigns.map(adCampaign => {
    const {
      hs_ad_campaign_id,
      hs_name
    } = adCampaign.properties;
    const {
      value: hsObjectId
    } = hs_ad_campaign_id;
    const {
      value: campaignName
    } = hs_name;
    return {
      text: campaignName,
      value: hsObjectId
    };
  });
});
export const getAdGroupOptions = createSelector([getAdCampaigns], adCampaigns => {
  if (!adCampaigns.length) return [];
  return adCampaigns.map(adCampaign => {
    const {
      hs_ad_group_id,
      hs_name
    } = adCampaign.properties;
    const {
      value: hsObjectId
    } = hs_ad_group_id;
    const {
      value: campaignName
    } = hs_name;
    return {
      text: campaignName,
      value: hsObjectId
    };
  });
});
export const getAdCampaignByObjId = createSelector([getAdCampaigns], adCampaigns => {
  return adCampaigns.reduce((campaignIdMap, adCampaign) => {
    const {
      hs_ad_campaign_id
    } = adCampaign.properties;
    const {
      value: hsObjectId
    } = hs_ad_campaign_id;
    campaignIdMap[hsObjectId] = adCampaign;
    return campaignIdMap;
  }, {});
});
export const getAdGroupsById = createSelector([getAdAccounts], byAccountId => {
  return Object.values(byAccountId).reduce((acc, adAccountObj) => {
    const {
      adGroups = {}
    } = adAccountObj;
    return Object.assign({}, acc, adGroups);
  }, {});
});
export const getAdSingletonByObjId = createSelector([getAdGroupsById], adGroups => {
  return Object.values(adGroups).reduce((adSingletonMap, adGroup) => {
    const {
      individualAds = {}
    } = adGroup;
    return Object.assign({}, adSingletonMap, individualAds);
  }, {});
});
export const getAdSourceFetchStatus = createSelector([getAdSourceListStatus], statuses => {
  const fetchStatuses = Object.values(statuses);
  if (contains(fetchStatuses, RequestStatus.FAILED)) {
    return RequestStatus.FAILED;
  } else if (contains(fetchStatuses, RequestStatus.PENDING)) {
    return RequestStatus.PENDING;
  } else if (contains(fetchStatuses, RequestStatus.SUCCEEDED)) {
    return RequestStatus.SUCCEEDED;
  }
  return RequestStatus.UNINITIALIZED;
});